import { useState } from "react";
import { CTabProps } from "../../Models/Common";
import { RefCodeType } from "../../Models/ReferenceCodes";
import { getRemoteValue } from "../../Utils/firebase";
import useAuthState from "../../Utils/store";
import CTab from "../CTab/CTab";
import EftTab from "./EftTab/EftTab";
import CardTab from "./MasterpassTab/MasterpassTab";

const PaymentMethod = ({ isAllPayment: initialIsAllPayment }: { isAllPayment: boolean }) => {
  const [isAllPayment] = useState(initialIsAllPayment);
  const { paymentMethod, user } = useAuthState();
  const activeTab =
    !(!(user && user?.features?.MASTERPASS_WHITELIST) ||
      paymentMethod?.type != RefCodeType.SPECIFIC);

  // Snooze durumu için sadece kredi kartı tab'ını göster
  if (paymentMethod?.type === 3) {
    const SnoozeTabProperty: CTabProps[] = [
      {
        id: 0,
        value: "card",
        label: getRemoteValue("credit_debt_pay"),
        component: (currentTab: number) => <CardTab isAllPayment={isAllPayment} />,
        path: "#card",
      }
    ];

    return (
      <section id="checkout-method" className="px-4 pt-0 pb-8 ml:py-8">
        <div className="hidden ml:block mx-1">
          <h2 color="#191B1E" className="xs:text-md md:text-xl font-bold">
            {getRemoteValue("payment_method")}
          </h2>
          <p className="pt-2 xs:text-sm md:text-base font-normal">
            {getRemoteValue("snooze_checkout_desc")}
          </p>
        </div>
        <CTab isNavigatePath sx={{ mt: 2 }} TabProperty={SnoozeTabProperty} />
      </section>
    );
  }

  // Diğer durumlar için mevcut yapıyı koru
  const CheckoutTabProperty: CTabProps[] = [
    {
      id: 0,
      value: "card",
      label: getRemoteValue("credit_debt_pay"),
      component: (currentTab: number) => {
        return <div className="px-4">
          <CardTab isAllPayment={isAllPayment} />
        </div>;
      },
      path: "#card",
      defaultTab: activeTab,
    },
    {
      id: 1,
      value: "eft",
      label: getRemoteValue("eft_pay"),
      component: (currentTab: number) => <div className="px-4 ">
        <EftTab />
      </div>
      ,
      path: "#eft",
    },

  ];

  return (
    <section id="checkout-method" className="pt-0 pb-8 ml:py-8">
      <div className="hidden ml:block mx-1">
        <h2 color="#191B1E" className="xs:text-md md:text-xl font-bold">
          {getRemoteValue("payment_method")}
        </h2>
        <p className="pt-2 xs:text-sm md:text-base font-normal">
          {getRemoteValue("eft_desc")}
        </p>
      </div>
      <CTab isNavigatePath sx={{ mt: 2 }} TabProperty={CheckoutTabProperty} />
    </section>
  );
};

export default PaymentMethod;
